module.exports = __webpack_public_path__ + "static/media/grid_icon.0ed55763.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grid_icon.svg
// module id = 177
// module chunks = 0